<div class="meter">
  <span [style.width]="value" [ngClass]="isNumber(width) ? bgColor : ''"></span>
  <span class="value" *ngIf="isValue && isNumber(width)" [style.marginLeft]="value !== '100%' ? value : 0"
  [ngClass]="value === '100%' ? 'r-3' : ''">
    {{width}}{{unit === '%' ? unit : ''}}
  </span>
</div>